"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagSelect = void 0;
var react_1 = __importStar(require("react"));
var getTypoComp_1 = require("../../utils/getTypoComp");
var styled_1 = require("./styled");
/**
 * @component Renders a tag select component with customizable text and styling.
 *
 * - The props object containing the following properties:
 * @prop {function} onClick: A function to be called when the tag is clicked. Called with the selected option as an argument.
 * @prop {boolean} isSelected: A boolean indicating whether the tag is selected. Defaults to false.
 * @prop {string} display: The text to be displayed in the tag.
 * @prop {string} value: The value of the tag.
 * @prop {boolean} M: A boolean indicating whether the tag should be medium in size. Defaults to false.
 * @prop {boolean} XS: A boolean indicating whether the tag should be extra small in size. Defaults to false.
 * @prop {boolean} invert: A boolean indicating whether to invert the tag colors. Defaults to false.
 * @prop {boolean} disabled: A boolean indicating whether the tag should be disabled. Defaults to false.
 * @prop {React.CSSProperties} style: Additional CSS styles to apply to the tag.
 * @prop {function} onMouseDown: A function to be called when the user mouses down on the tag. Called with the event as an argument.
 * @return {ReactElement} The rendered tag select component.
 */
var TagSelect = function (_a) {
    var onClick = _a.onClick, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, display = _a.display, value = _a.value, M = _a.M, XS = _a.XS, invert = _a.invert, disabled = _a.disabled, style = _a.style, onMouseDown = _a.onMouseDown;
    var _c = (0, react_1.useState)(isSelected), selected = _c[0], setSelected = _c[1];
    var handleOnClick = function () {
        setSelected(!selected);
        onClick && onClick({ display: display, value: value });
    };
    (0, react_1.useLayoutEffect)(function () {
        if (selected && !isSelected) {
            setSelected(isSelected);
        }
    }, [isSelected]);
    var size = M ? 'M' : XS ? 'XS' : 'S';
    var TYPO_COMP = (0, getTypoComp_1.getTypoComp)(size);
    return (react_1.default.createElement(styled_1.StyledTagSelect, { disabled: disabled, invert: invert, onClick: function () { return !onMouseDown && !disabled && handleOnClick(); }, selected: selected, size: size, style: style, onMouseDown: function (ev) {
            return !disabled && onMouseDown && onMouseDown(ev);
        } },
        react_1.default.createElement(TYPO_COMP, null, display)));
};
exports.TagSelect = TagSelect;
